import { Box, Container, Stack } from "@bilar/ui";
import { SignIn } from "@bilar/features";
import { BasePageProps, RouteTransition } from "@bilar/common";
import {
	GetStaticProps,
	GetStaticPropsContext,
	GetStaticPropsResult,
} from "next";
import { getBasePagePropsData } from "@bilar/pages-common";
import { useRouter } from "next/router";
import { AuthStatus } from "@bilar/auth";

type SignInPageProps = {} & BasePageProps;

const SignInPage = (props: SignInPageProps) => {
	const router = useRouter();

	const handleSignInSuccess = (authStatus: AuthStatus) => {
		if (authStatus === "signInComplete") {
			router.push("/");
		}
	};

	return (
		<RouteTransition>
			<Container>
				<Stack horizontalAlignment="center">
					<Box width={["100%", "50%"]}>
						<SignIn onSignInSuccess={handleSignInSuccess} />
					</Box>
				</Stack>
			</Container>
		</RouteTransition>
	);
};

export const getStaticProps: GetStaticProps<SignInPageProps> = async (
	ctx: GetStaticPropsContext,
): Promise<GetStaticPropsResult<SignInPageProps>> => {
	// Get Locale and common translations
	const baseProps = await getBasePagePropsData(ctx);

	return {
		props: {
			...baseProps,
		},
		// we will attempt to re-generate the page:
		// - when a request comes in
		// - at most once every second
		//revalidate: 60,
	};
};

export default SignInPage;
